import React from 'react';
import TituloComponent from '../../components/Titulo/TituloComponent';
import './BuscarPage.css'; // Seu CSS customizado

const BuscarPage = () => {
  return (
    <div className="buscar-container">
      <TituloComponent /> {/* Adiciona o título fixo no topo */}

      <div>
        <h2>Buscar</h2>
        {/* Conteúdo da página de Buscar */}
      </div>
    </div>
  );
};

export default BuscarPage;
